import React, { useState, useEffect } from 'react';
import { NavButton } from './NavButton';

export const SectionNav = ({ 
  sections, 
  onSectionClick, 
  isVisible = true,
  className = '' 
}) => {
  const [activeSection, setActiveSection] = useState('');

  useEffect(() => {
    if (!isVisible) return;

    const observerOptions = {
      root: null,
      rootMargin: '-20% 0px -70% 0px', // Trigger when section is in the middle of viewport
      threshold: 0
    };

    const observerCallback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setActiveSection(entry.target.id);
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    // Observe all sections
    sections.forEach(({ id }) => {
      const element = document.getElementById(id);
      if (element) {
        observer.observe(element);
      }
    });

    return () => {
      observer.disconnect();
    };
  }, [sections, isVisible]);

  if (!isVisible) return null;

  return (
    <>
      {sections.map(({ id, labelKey }) => (
        <NavButton
          key={id}
          onClick={() => onSectionClick(id)}
          className={`${className} ${activeSection === id ? 'border-b-2 border-blue-500' : ''}`}
        >
          {labelKey}
        </NavButton>
      ))}
    </>
  );
};